import { Capacitor } from '@capacitor/core';
import { CAPACITOR_SAFE_AREA_PLUGIN } from '../../../capacitor_plugins/pluginConstants';
import {
    SafeArea,
    SafeAreaBottomKeyboardData,
    SafeAreaData,
    SafeAreaInsetData,
} from '../../../capacitor_plugins/safeArea';
import safeAreaSingleton from './safeAreaSingleton';

const updateSafeAreaValues = (safeAreaData: SafeAreaData) => {
    const body = document.body;

    safeAreaSingleton.setSafeAreaData(safeAreaData);

    (Object.keys(safeAreaData.safeAreaInsets) as Array<keyof SafeAreaInsetData>)?.forEach((key) => {
        body.style.setProperty(`--capacitor-safe-area-${key}`, `${safeAreaData.safeAreaInsets[key] || 0}px`);
    });

    (Object.keys(safeAreaData.safeAreaKeyboard) as Array<keyof SafeAreaBottomKeyboardData>)?.forEach((key) => {
        body.style.setProperty(`--keyboard-toolbar-bottom-${key}`, `${safeAreaData.safeAreaKeyboard[key] || 0}px`);
    });
};

/**
 * Adds the safe area values to the root element.
 * This is necessary especially for loading screens since the css safe-area-inset-* values
 * are not available immediately and cause a flicker when the safe area is applied.
 */
export const addCapacitorSafeAreaValues = () => {
    if (Capacitor.isPluginAvailable(CAPACITOR_SAFE_AREA_PLUGIN)) {
        (async () => {
            await SafeArea.currentSafeArea().then(updateSafeAreaValues);

            SafeArea.addListener('safeAreaChanged', updateSafeAreaValues);
        })();
    }
};
